export default __webpack_public_path__ + "static/banner-one-shape5-326da2fb23cf347e731fb02a8bd5299d.png";